import { ModelSummaryStatus } from './model-summary-status';

export class ModelVisualizator {
  constructor(
    public modelHash?: string,
    public modelReference?: number,
    public modelName?: string,
    public status?: ModelSummaryStatus,
    public isNotRealPieceTime?: boolean,
    public lastPieceTimeBigger?: boolean,
    public lastPieceTimeLower?: boolean
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-visualizator.ts